module.exports = __webpack_public_path__ + "img/logo_dk_mark@2x.188cf0be.png";